import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="border-b border-line bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-131" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto w-full max-w-2xl rounded-2xl border border-lime/30 bg-surface p-6 text-center sm:p-8" data-id="element-132" data-mp="222d9lehckiko">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-lime/12" data-id="element-133" data-mp="1x4uzvlvi9zbm">
          <ShieldCheckIcon className="h-8 w-8 text-lime" aria-hidden="true" data-id="element-134" data-mp="19facmqsbkfwj" />
        </span>
        <h2 className="mt-5 font-display text-[26px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-135" data-mp="14gz7uugvsvl6">
          Garantie inconditionnelle de 7 jours
        </h2>
        <p className="mt-4 text-[15px] leading-relaxed text-slate-300" data-id="element-136" data-mp="1edbwvf1hel9l">
          Explorez les 6 volumes. Consultez les algorithmes. Utilisez les outils dans votre pratique
          clinique.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-slate-400" data-id="element-137" data-mp="lpy8w6frh01m">
          Si, au cours des sept prochains jours, vous estimez que Route Maladie Rénale™ ne vous
          apporte pas davantage de clarté clinique, écrivez-nous simplement. Nous vous rembourserons
          100 % de votre paiement.
        </p>
        <p className="mt-4 text-[15px] font-semibold text-lime" data-id="element-138" data-mp="yqmcllsu9pof">
          Sans justification. Sans formulaires interminables. Sans risque.
        </p>

        <div className="mt-8" data-id="element-139" data-mp="60nk1gffraf0">
          <CTAButton label="Je veux l’essayer sans risque" caption="Votre achat est entièrement protégé pendant 7 jours" data-id="element-140" data-mp="61fh6voolg7e" />
        </div>
      </div>
    </section>;
}